module.exports = __webpack_public_path__ + "static/img/logo_20.7175b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_20.png
// module id = DAvp
// module chunks = 1